<template>
  <el-col :span="7" style="height: 100%">
    <div class="notice">
      <div class="swiper-content" ref="swiperRef">
        <swiper class="swiper" :options="swiperOption">
          <swiper-slide v-for="(item, index) in swiperList" :key="index" @click.native="bannerTo(item)">
            <img :src="item.imgUrl" />
          </swiper-slide>
          <!-- <swiper-slide>
            <img src="../../assets/images/home/banner.png" />
          </swiper-slide>
          <swiper-slide>
            <img src="../../assets/images/home/banner.png" />
          </swiper-slide>
          <swiper-slide>
            <img src="../../assets/images/home/banner.png" />
          </swiper-slide> -->
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <div class="head">
        <span>公告</span>
        <!-- <a href="https://www.yuque.com/yunduanxincrm/kw5ag6" style="text-decoration: none" target="_blank">
          <span class="more">更多</span>
        </a> -->
      </div>
      <div class="content">
        <ul>
          <li v-for="(item, index) in noticeList" :key="index" @click="navTo(item.url, item)">
            <div class="left">
              <div class="icon c1" v-if="item.type === 0">通知</div>
              <div class="icon c2" v-if="item.type === 1">活动</div>
              <div class="icon c2" v-if="item.type === 2" style="width:50px">新功能</div>
              <div class="icon c3" v-if="item.type === 3">下线</div>
              <p class="info" :class="item.type === 0 ? 'c1' : item.type === 1 || item.type === 2 ? 'c2' : 'c3'">
                {{ item.title }}
              </p>
            </div>
            <p class="time">{{ item.createDate.substring(0, 10) }}</p>
          </li>
        </ul>
      </div>
    </div>

    <!-- 公告内容弹窗 -->
    <el-dialog title="系统公告" width="800px" :visible.sync="noticeDialogVisible" :close-on-click-modal="false">
      <div style="height: 500px;overflow-y: auto;padding-bottom: 20px;" v-html="linkContent"></div>
    </el-dialog>
  </el-col>
</template>

<script>
import { getNotice, getHomeGetCarousel } from "@/api/homePage";
export default {
  data() {
    return {
      swiperList: [],
      noticeDialogVisible: false,
      linkContent: "",
      swiperOption: {
        autoplay: true,
        speed: 800,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },

      noticeList: [],
      heightData: 0,
    };
  },
  methods: {
    navTo(url, item) {
      if (url.length == "0") {
        this.noticeDialogVisible = true;
        this.linkContent = item.content;
        return;
      } else {
        // let routeUrl = this.$router.resolve({
        //   path: "/orderCare",
        //   query: {to:'/orderCare/urgorder/regurg'}
        // });
        // window.open(routeUrl.href, '_blank');
        window.open(url, "_blank");
      }
      // window.open(item.url);
    },
    bannerTo(item) {
      if (item.pathType != "2") {
        window.open(item.pathUrl);
      }

      // var routeUrl = this.$router.resolve({
      //   path: item.pathUrl
      // })
      // window.open(routeUrl.href, '_blank');
    },
  },
  mounted() {
    getNotice().then((res) => {
      if (res.code == "1") {
        this.noticeList = res.data;
        var that = this;
        this.$nextTick(function() {
          var height = this.$refs.swiperRef.offsetHeight;
          that.heightData = 460 - height - 21 - 60 + "px";
        });
      }
    });

    getHomeGetCarousel().then((res) => {
      if (res.code == "1") {
        this.swiperList = res.data;
      }
    });
  },
};
</script>

<style scoped lang="scss">
.notice {
  height: 100%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.06);
  border-radius: 6px;
  overflow: hidden;
  .swiper-content {
    box-sizing: border-box;
    padding: 20px 24px;
    // border-bottom: 1px solid #F6F6F6;
    .swiper {
      // height: 214px;
      border-radius: 6px;
      img {
        width: 100%;
        max-height: 230px;
        // height: 100%;
        @media screen and (max-width: 1370px) {
          max-height: 155px;
        }
        @media screen and (max-width: 1290px) {
          max-height: 138px;
        }
      }
    }
  }
  .head {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // height: 54px;
    padding: 0 24px;
    span {
      color: #000000;
      font-size: 16px;
      font-weight: 800;
    }
    img {
      width: 18px;
      height: 18px;
      cursor: pointer;
    }
    // border-bottom: 1px solid #F6F6F6;
    .more {
      color: #999999;
      font-size: 14px;
      cursor: pointer;
    }
  }
  .content {
    box-sizing: border-box;
    padding: 0 24px 18px 27px;
    // height: 150px;
    overflow: auto;
    height: 150px;
    margin-top: 17px;
    p {
      margin: 0;
      padding: 0;
    }
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
        cursor: pointer;
        &:last-child {
          margin: 0;
        }
        .left {
          flex: 1;
          display: flex;
          align-items: center;
          width: 0;
          .info {
            width: 80%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .icon {
            box-sizing: border-box;
            width: 34px;
            height: 18px;
            line-height: 16px;
            margin-right: 5px;
            text-align: center;
            font-size: 11px;
            border-radius: 2px;
          }
          .icon.c1 {
            border: 1px solid #fe4d45;
            color: #fe4d45;
          }
          .icon.c2 {
            border: 1px solid #7f85e9;
            color: #7f85e9;
          }
          .icon.c3 {
            border: 1px solid #ff872f;
            color: #ff872f;
          }
          .info {
            font-size: 14px;
            font-weight: 500;
          }
          .info.c1 {
            color: #333333;
            // font-family: PingFang SC;
            font-weight: 400;
            &:hover {
              color: #fe4d45;
            }
          }
          .info.c2 {
            color: #333333;
            // font-family: PingFang SC;
            font-weight: 400;
            &:hover {
              color: #fe4d45;
            }
          }
          .info.c3 {
            color: #333333;
            // font-family: PingFang SC;s
            font-weight: 400;
            &:hover {
              color: #fe4d45;
            }
          }
        }
        .time {
          flex-shrink: 0;
          color: #666;
          font-size: 14px;
          font-weight: 400;
          text-align: right;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.swiper-pagination {
  text-align: right;
  padding-right: 18px;
  .swiper-pagination-bullet {
    width: 6px;
    height: 6px;
    background: rgba(255, 255, 255, 1);
    border-radius: 50%;
    opacity: 0.6;
  }
  .swiper-pagination-bullet .swiper-pagination-bullet-active {
    width: 24px;
    border-radius: 3px;
    opacity: 1;
  }
}
</style>
